import React from "react";
import {
  Alert,
  Button,
  Grid,
  Header,
  SpaceBetween,
  Spinner,
  Table,
} from "@amzn/awsui-components-console";
import { useNavigate } from "react-router-dom";
import "../../pages/commons/common.styles.scss";
import Collapsible from "src/pages/commons/collapsible";
import { configureDomain } from "src/auth/config";
import { getBartPortalUrl } from "src/config/BartLambdaConfig";
import { URLS } from "src/components/constants/appConstants";
interface PayloadProps {
  searchResults: any;
  searchId: string;
}

const NavigateButton = ({
  to,
  children,
}: {
  to: string;
  children: React.ReactNode;
}) => {
  const navigate = useNavigate();
  return <Button onClick={() => navigate(to)}>{children}</Button>;
};

export class PayloadDisplayPlan extends React.Component<
  PayloadProps,
  { searchId: string }
> {
  constructor(props: any) {
    super(props);
    this.state = {
      searchId: this.props.searchId,
    };
  }

  render() {
    const { searchResults, searchId } = this.props;
    const Domain = configureDomain;
    const planIdFenderLink = ((domain) => {
      switch (domain) {
        case "prod-FE":
          return "https://fender.corp.amazon.com/domains/prod-FE/plans/";
        case "prod-US":
          return "https://fender.corp.amazon.com/domains/prod-NA/plans/";
        case "prod-EU":
          return "https://fender.corp.amazon.com/domains/prod-EU/plans/";
      }
      return "https://fender.corp.amazon.com/domains/devo-FE/plans/";
    })(Domain);
    const ardIdLink = getBartPortalUrl(Domain, "/jemgen?selectedArdId=");
    if (searchResults != "init") {
      if (!searchResults.plan) {
        return (
          <div>
            <Grid gridDefinition={[{ colspan: { l: 7, xxs: 10 } }]}>
              <Alert header={searchResults} type="error"></Alert>
            </Grid>
          </div>
        );
      }
      const planDefinitions: any[] = [];
      planDefinitions.push({
        id: "",
        header: "",
        cell: () => "",
      });
      planDefinitions.push({
        id: "planId",
        header: "plan id",
        cell: (item: any) => (
          <a
            href={planIdFenderLink + item["plan"]["id"].toString()}
            target="_blank"
          >
            {item["plan"]["id"].toString()}
          </a>
        ),
      });
      planDefinitions.push({
        id: "ardId",
        header: "ard id",
        cell: (item: any) => (
          <a
            href={ardIdLink + item["plan"]["ardId"].toString()}
            target="_blank"
          >
            {item["plan"]["ardId"].toString()}
          </a>
        ),
      });
      planDefinitions.push({
        id: "fusenEnabled",
        header: "fusen enabled",
        cell: (item: any) => item["plan"]["fusenEnabled"].toString(),
      });
      planDefinitions.push({
        id: "glLineDescriptionPartnerName",
        header: "gl line description partner name",
        cell: (item: any) => item["plan"]["glLineDescriptionPartnerName"],
      });
      planDefinitions.push({
        id: "fusenEnableDate",
        header: "fusen enabled date",
        cell: (item: any) => item["plan"]["fusenEnableDate"],
      });
      planDefinitions.push({
        id: "migrationTargetStage",
        header: "migration target stage",
        cell: (item: any) => item["plan"]["migrationTargetStage"],
      });
      planDefinitions.push({
        id: "",
        header: "",
        cell: () => "",
      });
      let table = (
        <Table
          columnDefinitions={planDefinitions}
          items={[searchResults]}
          wrapLines={false}
          resizableColumns={false}
          header={
            <Header
              actions={
                <NavigateButton
                  to={`${URLS.UPDATE_PLAN}/${searchResults["plan"]["id"]}`}
                >
                  Update
                </NavigateButton>
              }
            >
              Plan Information
            </Header>
          }
        ></Table>
      );
      let ragaControlParameters: any[] = [];
      ragaControlParameters.push({
        id: "",
        header: "",
        cell: () => "",
      });
      ragaControlParameters.push({
        id: "billingMode",
        header: "billingMode",
        cell: (item: any) => item["plan"]["ard"]["billingMode"],
      });
      ragaControlParameters.push({
        id: "term",
        header: "term",
        cell: (item: any) => item["plan"]["ard"]["term"],
      });
      ragaControlParameters.push({
        id: "product",
        header: "product",
        cell: (item: any) => item["plan"]["ard"]["product"],
      });
      ragaControlParameters.push({
        id: "glLineDescriptionPartnerName",
        header: "gl line description partner name",
        cell: (item: any) => item["plan"]["glLineDescriptionPartnerName"],
      });
      ragaControlParameters.push({
        id: "businessCountryCode",
        header: "business country code",
        cell: (item: any) => item["plan"]["ard"]["businessCountryCode"],
      });
      ragaControlParameters.push({
        id: "buyingCustomerCountryCode",
        header: "buying customer country code",
        cell: (item: any) => item["plan"]["ard"]["buyingCustomerCountryCode"],
      });
      ragaControlParameters.push({
        id: "fusenEnabled",
        header: "fusen enabled",
        cell: (item: any) => item["plan"]["fusenEnabled"].toString(),
      });
      ragaControlParameters.push({
        id: "fusenEnableDate",
        header: "fusen enable date",
        cell: (item: any) => item["plan"]["fusenEnableDate"],
      });
      ragaControlParameters.push({
        id: "migrationTargetStage",
        header: "migration target stage",
        cell: (item: any) => item["plan"]["migrationTargetStage"],
      });
      ragaControlParameters.push({
        id: "",
        header: "",
        cell: () => "",
      });
      let ragaTable = (
        <Table
          columnDefinitions={ragaControlParameters}
          items={[searchResults]}
          wrapLines={false}
          resizableColumns={false}
          header={<Header>Important Source Fields for Plan</Header>}
        ></Table>
      );
      let ardInfo: any[] = [];
      ardInfo.push({
        id: "",
        header: "",
        cell: () => "",
      });
      ardInfo.push({
        id: "id",
        header: "id",
        cell: (item: any) => (
          <a
            href={ardIdLink + item["plan"]["ardId"].toString()}
            target="_blank"
          >
            {item["plan"]["ardId"].toString()}
          </a>
        ),
      });
      ardInfo.push({
        id: "billingMode",
        header: "billingMode",
        cell: (item: any) => item["plan"]["ard"]["billingMode"],
      });
      ardInfo.push({
        id: "product",
        header: "product",
        cell: (item: any) => item["plan"]["ard"]["product"],
      });
      ardInfo.push({
        id: "term",
        header: "term",
        cell: (item: any) => item["plan"]["ard"]["term"],
      });
      ardInfo.push({
        id: "template",
        header: "template",
        cell: (item: any) => item["plan"]["ard"]["template"],
      });
      ardInfo.push({
        id: "businessCountryCode",
        header: "business country code",
        cell: (item: any) => item["plan"]["ard"]["businessCountryCode"],
      });
      ardInfo.push({
        id: "buyingCustomerCountryCode",
        header: "buying customer country code",
        cell: (item: any) => item["plan"]["ard"]["buyingCustomerCountryCode"],
      });
      ardInfo.push({
        id: "functionalCurrency",
        header: "functional currency",
        cell: (item: any) => item["plan"]["ard"]["functionalCurrency"],
      });
      ardInfo.push({
        id: "localCurrency",
        header: "local currency",
        cell: (item: any) => item["plan"]["ard"]["localCurrency"],
      });
      ardInfo.push({
        id: "",
        header: "",
        cell: () => "",
      });
      let ardInfoTable = (
        <Table
          columnDefinitions={ardInfo}
          items={[searchResults]}
          wrapLines={false}
          resizableColumns={false}
          header={
            <Header
              actions={
                <NavigateButton
                  to={`${URLS.LINK_ARD_TO_A_PLAN}/${searchResults["plan"]["id"]}`}
                >
                  Re-map
                </NavigateButton>
              }
            >
              ARD Information for Plan
            </Header>
          }
        ></Table>
      );

      let hasRegistration = searchResults.plan.registration;
      let registrationInfo: any[] = [];
      if (hasRegistration) {
        registrationInfo.push({
          id: "",
          header: "",
          cell: () => "",
        });
        registrationInfo.push({
          id: "accountingRegistrationId",
          header: "accountingRegistrationId",
          cell: (item: any) =>
            item["plan"]["registration"]["accountingRegistrationId"],
        });
        registrationInfo.push({
          id: "billingMode",
          header: "billingMode",
          cell: (item: any) => item["plan"]["registration"]["billingMode"],
        });
        registrationInfo.push({
          id: "description",
          header: "description",
          cell: (item: any) => item["plan"]["registration"]["description"],
        });
        registrationInfo.push({
          id: "",
          header: "",
          cell: () => "",
        });
      }

      let registrationTable = (
        <Table
          columnDefinitions={registrationInfo}
          items={[searchResults]}
          wrapLines={false}
          resizableColumns={false}
          header={<Header>Registration Information for Plan</Header>}
        ></Table>
      );
      let source = (
        <Collapsible
          open={false}
          title={"Full Source for Plan " + searchResults["plan"]["id"]}
        >
          <pre className="sourceInfo ">
            {JSON.stringify(searchResults.plan, null, 2)}
          </pre>
        </Collapsible>
      );
      return (
        <div style={{ paddingLeft: "10px" }}>
          <SpaceBetween size="l">
            {table}
            {ragaTable}
            {ardInfoTable}
            {hasRegistration ? registrationTable : null}
            {source}
          </SpaceBetween>
        </div>
      );
    } else {
      return <Spinner size="large"></Spinner>;
    }
  }
}

export default PayloadDisplayPlan;
